export const languages = [
  { flag: '🇨🇳', name: 'Chinese', value: 'chinese' },
  { flag: '🇬🇧', name: 'English', value: 'english' },
  { flag: '🇫🇷', name: 'French', value: 'french' },
  { flag: '🇩🇪', name: 'German', value: 'german' },
  { flag: '🇮🇹', name: 'Italian', value: 'italian' },
  { flag: '🇯🇵', name: 'Japanese', value: 'japanese' },
  { flag: '🇰🇿', name: 'Kazakh', value: 'kazakh' },
  { flag: '🇵🇱', name: 'Polish', value: 'polish' },
  { flag: '🇵🇹', name: 'Portuguese', value: 'portuguese' },
  { flag: '🇷🇺', name: 'Russian', value: 'russian' },
  { flag: '🇪🇸', name: 'Spanish', value: 'spanish' },
  { flag: '🇺🇦', name: 'Ukrainian', value: 'ukrainian' }
];

export const nativeLanguages = [
  { flag: '🇸🇦', name: 'Arabic', value: 'arabic' },
  { flag: '🇦🇲', name: 'Armenian', value: 'armenian' },
  { flag: '🇨🇳', name: 'Chinese', value: 'chinese' },
  { flag: '🇨🇿', name: 'Czech', value: 'czech' },
  { flag: '🇩🇰', name: 'Danish', value: 'danish' },
  { flag: '🇳🇱', name: 'Dutch', value: 'dutch' },
  { flag: '🇬🇧', name: 'English', value: 'english' },
  { flag: '🇫🇮', name: 'Finnish', value: 'finnish' },
  { flag: '🇫🇷', name: 'French', value: 'french' },
  { flag: '🇩🇪', name: 'German', value: 'german' },
  { flag: '🇬🇷', name: 'Greek', value: 'greek' },
  { flag: '🇮🇱', name: 'Hebrew', value: 'hebrew' },
  { flag: '🇮🇳', name: 'Hindi', value: 'hindi' },
  { flag: '🇮🇸', name: 'Icelandic', value: 'icelandic' },
  { flag: '🇮🇹', name: 'Italian', value: 'italian' },
  { flag: '🇯🇵', name: 'Japanese', value: 'japanese' },
  { flag: '🇰🇷', name: 'Korean', value: 'korean' },
  { flag: '🇳🇴', name: 'Norwegian', value: 'norwegian' },
  { flag: '🇵🇱', name: 'Polish', value: 'polish' },
  { flag: '🇵🇹', name: 'Portuguese', value: 'portuguese' },
  { flag: '🇷🇴', name: 'Romanian', value: 'romanian' },
  { flag: '🇷🇺', name: 'Russian', value: 'russian' },
  { flag: '🇪🇸', name: 'Spanish', value: 'spanish' },
  { flag: '🇸🇪', name: 'Swedish', value: 'swedish' },
  { flag: '🇹🇷', name: 'Turkish', value: 'turkish' },
  { flag: '🇺🇦', name: 'Ukrainian', value: 'ukrainian' }
];

export const countries = [
  { flag: '🇦🇫', name: 'Afghanistan', value: 'afghanistan' },
  { flag: '🇦🇱', name: 'Albania', value: 'albania' },
  { flag: '🇩🇿', name: 'Algeria', value: 'algeria' },
  { flag: '🇦🇩', name: 'Andorra', value: 'andorra' },
  { flag: '🇦🇴', name: 'Angola', value: 'angola' },
  { flag: '🇦🇮', name: 'Anguilla', value: 'anguilla' },
  { flag: '🇦🇬', name: 'Antigua and Barbuda', value: 'antigua_and_barbuda' },
  { flag: '🇦🇷', name: 'Argentina', value: 'argentina' },
  { flag: '🇦🇲', name: 'Armenia', value: 'armenia' },
  { flag: '🇦🇼', name: 'Aruba', value: 'aruba' },
  { flag: '🇦🇺', name: 'Australia', value: 'australia' },
  { flag: '🇦🇹', name: 'Austria', value: 'austria' },
  { flag: '🇦🇿', name: 'Azerbaijan', value: 'azerbaijan' },
  { flag: '🇧🇸', name: 'Bahamas', value: 'bahamas' },
  { flag: '🇧🇭', name: 'Bahrain', value: 'bahrain' },
  { flag: '🇧🇩', name: 'Bangladesh', value: 'bangladesh' },
  { flag: '🇧🇧', name: 'Barbados', value: 'barbados' },
  { flag: '🇧🇾', name: 'Belarus', value: 'belarus' },
  { flag: '🇧🇪', name: 'Belgium', value: 'belgium' },
  { flag: '🇧🇿', name: 'Belize', value: 'belize' },
  { flag: '🇧🇯', name: 'Benin', value: 'benin' },
  { flag: '🇧🇲', name: 'Bermuda', value: 'bermuda' },
  { flag: '🇧🇹', name: 'Bhutan', value: 'bhutan' },
  { flag: '🇧🇴', name: 'Bolivia', value: 'bolivia' },
  { flag: '🇧🇶', name: 'Bonaire, Sint Eustatius and Saba', value: 'bonaire' },
  { flag: '🇧🇦', name: 'Bosnia and Herzegovina', value: 'bosnia_and_herzegovina' },
  { flag: '🇧🇼', name: 'Botswana', value: 'botswana' },
  { flag: '🇧🇷', name: 'Brazil', value: 'brazil' },
  { flag: '🇻🇬', name: 'British Virgin Islands', value: 'british_virgin_islands' },
  { flag: '🇧🇳', name: 'Brunei', value: 'brunei' },
  { flag: '🇧🇬', name: 'Bulgaria', value: 'bulgaria' },
  { flag: '🇧🇫', name: 'Burkina Faso', value: 'burkina_faso' },
  { flag: '🇲🇲', name: 'Burma', value: 'burma' },
  { flag: '🇧🇮', name: 'Burundi', value: 'burundi' },
  { flag: '🇰🇭', name: 'Cambodia', value: 'cambodia' },
  { flag: '🇨🇲', name: 'Cameroon', value: 'cameroon' },
  { flag: '🇨🇦', name: 'Canada', value: 'canada' },
  { flag: '🇨🇻', name: 'Cape Verde', value: 'cape_verde' },
  { flag: '🇰🇾', name: 'Cayman Islands', value: 'cayman_islands' },
  { flag: '🇨🇫', name: 'Central African Republic', value: 'central_african_republic' },
  { flag: '🇹🇩', name: 'Chad', value: 'chad' },
  { flag: '🇨🇱', name: 'Chile', value: 'chile' },
  { flag: '🇨🇳', name: 'China', value: 'china' },
  { flag: '🇨🇴', name: 'Colombia', value: 'colombia' },
  { flag: '🇰🇲', name: 'Comoros', value: 'comoros' },
  { flag: '🇨🇩', name: 'Congo, Democratic Republic of the', value: 'congo_democratic' },
  { flag: '🇨🇬', name: 'Congo, Republic of the', value: 'congo_republic' },
  { flag: '🇨🇷', name: 'Costa Rica', value: 'costa_rica' },
  { flag: '🇨🇮', name: 'Cote d\'Ivoire', value: 'cote_divoire' },
  { flag: '🇭🇷', name: 'Croatia', value: 'croatia' },
  { flag: '🇨🇺', name: 'Cuba', value: 'cuba' },
  { flag: '🇨🇼', name: 'Curacao', value: 'curacao' },
  { flag: '🇨🇾', name: 'Cyprus', value: 'cyprus' },
  { flag: '🇨🇿', name: 'Czech Republic', value: 'czech_republic' },
  { flag: '🇩🇰', name: 'Denmark', value: 'denmark' },
  { flag: '🇩🇯', name: 'Djibouti', value: 'djibouti' },
  { flag: '🇩🇲', name: 'Dominica', value: 'dominica' },
  { flag: '🇩🇴', name: 'Dominican Republic', value: 'dominican_republic' },
  { flag: '🇪🇨', name: 'Ecuador', value: 'ecuador' },
  { flag: '🇪🇬', name: 'Egypt', value: 'egypt' },
  { flag: '🇸🇻', name: 'El Salvador', value: 'el_salvador' },
  { flag: '🇬🇶', name: 'Equatorial Guinea', value: 'equatorial_guinea' },
  { flag: '🇪🇷', name: 'Eritrea', value: 'eritrea' },
  { flag: '🇪🇪', name: 'Estonia', value: 'estonia' },
  { flag: '🇸🇿', name: 'Eswatini', value: 'eswatini' },
  { flag: '🇪🇹', name: 'Ethiopia', value: 'ethiopia' },
  { flag: '🇫🇰', name: 'Falkland Islands', value: 'falkland_islands' },
  { flag: '🇫🇴', name: 'Faroe Islands', value: 'faroe_islands' },
  { flag: '🇫🇯', name: 'Fiji', value: 'fiji' },
  { flag: '🇫🇮', name: 'Finland', value: 'finland' },
  { flag: '🇫🇷', name: 'France', value: 'france' },
  { flag: '🇬🇫', name: 'French Guiana', value: 'french_guiana' },
  { flag: '🇵🇫', name: 'French Polynesia', value: 'french_polynesia' },
  { flag: '🇬🇦', name: 'Gabon', value: 'gabon' },
  { flag: '🇬🇲', name: 'Gambia', value: 'gambia' },
  { flag: '🇬🇪', name: 'Georgia', value: 'georgia' },
  { flag: '🇩🇪', name: 'Germany', value: 'germany' },
  { flag: '🇬🇭', name: 'Ghana', value: 'ghana' },
  { flag: '🇬🇮', name: 'Gibraltar', value: 'gibraltar' },
  { flag: '🇬🇷', name: 'Greece', value: 'greece' },
  { flag: '🇬🇱', name: 'Greenland', value: 'greenland' },
  { flag: '🇬🇩', name: 'Grenada', value: 'grenada' },
  { flag: '🇬🇵', name: 'Guadeloupe', value: 'guadeloupe' },
  { flag: '🇬🇺', name: 'Guam', value: 'guam' },
  { flag: '🇬🇹', name: 'Guatemala', value: 'guatemala' },
  { flag: '🇬🇬', name: 'Guernsey', value: 'guernsey' },
  { flag: '🇬🇳', name: 'Guinea', value: 'guinea' },
  { flag: '🇬🇼', name: 'Guinea-Bissau', value: 'guinea_bissau' },
  { flag: '🇬🇾', name: 'Guyana', value: 'guyana' },
  { flag: '🇭🇹', name: 'Haiti', value: 'haiti' },
  { flag: '🇭🇳', name: 'Honduras', value: 'honduras' },
  { flag: '🇭🇰', name: 'Hong Kong', value: 'hong_kong' },
  { flag: '🇭🇺', name: 'Hungary', value: 'hungary' },
  { flag: '🇮🇸', name: 'Iceland', value: 'iceland' },
  { flag: '🇮🇳', name: 'India', value: 'india' },
  { flag: '🇮🇩', name: 'Indonesia', value: 'indonesia' },
  { flag: '🇮🇷', name: 'Iran', value: 'iran' },
  { flag: '🇮🇶', name: 'Iraq', value: 'iraq' },
  { flag: '🇮🇪', name: 'Ireland', value: 'ireland' },
  { flag: '🇮🇱', name: 'Israel', value: 'israel' },
  { flag: '🇮🇹', name: 'Italy', value: 'italy' },
  { flag: '🇯🇲', name: 'Jamaica', value: 'jamaica' },
  { flag: '🇯🇵', name: 'Japan', value: 'japan' },
  { flag: '🇯🇴', name: 'Jordan', value: 'jordan' },
  { flag: '🇰🇿', name: 'Kazakhstan', value: 'kazakhstan' },
  { flag: '🇰🇪', name: 'Kenya', value: 'kenya' },
  { flag: '🇰🇮', name: 'Kiribati', value: 'kiribati' },
  { flag: '🇰🇵', name: 'Korea, Democratic Peoples Republic of (North Korea)', value: 'north_korea' },
  { flag: '🇰🇷', name: 'Korea, Republic of (South Korea)', value: 'south_korea' },
  { flag: '🇽🇰', name: 'Kosovo, Republic of', value: 'kosovo' },
  { flag: '🇰🇼', name: 'Kuwait', value: 'kuwait' },
  { flag: '🇰🇬', name: 'Kyrgyzstan', value: 'kyrgyzstan' },
  { flag: '🇱🇦', name: 'Laos', value: 'laos' },
  { flag: '🇱🇻', name: 'Latvia', value: 'latvia' },
  { flag: '🇱🇧', name: 'Lebanon', value: 'lebanon' },
  { flag: '🇱🇸', name: 'Lesotho', value: 'lesotho' },
  { flag: '🇱🇷', name: 'Liberia', value: 'liberia' },
  { flag: '🇱🇾', name: 'Libya', value: 'libya' },
  { flag: '🇱🇮', name: 'Liechtenstein', value: 'liechtenstein' },
  { flag: '🇱🇹', name: 'Lithuania', value: 'lithuania' },
  { flag: '🇱🇺', name: 'Luxembourg', value: 'luxembourg' },
  { flag: '🇲🇴', name: 'Macau', value: 'macau' },
  { flag: '🇲🇬', name: 'Madagascar', value: 'madagascar' },
  { flag: '🇲🇼', name: 'Malawi', value: 'malawi' },
  { flag: '🇲🇾', name: 'Malaysia', value: 'malaysia' },
  { flag: '🇲🇻', name: 'Maldives', value: 'maldives' },
  { flag: '🇲🇱', name: 'Mali', value: 'mali' },
  { flag: '🇲🇹', name: 'Malta', value: 'malta' },
  { flag: '🇲🇭', name: 'Marshall Islands', value: 'marshall_islands' },
  { flag: '🇲🇶', name: 'Martinique', value: 'martinique' },
  { flag: '🇲🇷', name: 'Mauritania', value: 'mauritania' },
  { flag: '🇲🇺', name: 'Mauritius', value: 'mauritius' },
  { flag: '🇲🇽', name: 'Mexico', value: 'mexico' },
  { flag: '🇫🇲', name: 'Micronesia', value: 'micronesia' },
  { flag: '🇲🇩', name: 'Moldova', value: 'moldova' },
  { flag: '🇲🇨', name: 'Monaco', value: 'monaco' },
  { flag: '🇲🇳', name: 'Mongolia', value: 'mongolia' },
  { flag: '🇲🇪', name: 'Montenegro', value: 'montenegro' },
  { flag: '🇲🇸', name: 'Montserrat', value: 'montserrat' },
  { flag: '🇲🇦', name: 'Morocco', value: 'morocco' },
  { flag: '🇲🇿', name: 'Mozambique', value: 'mozambique' },
  { flag: '🇲🇲', name: 'Myanmar', value: 'myanmar' },
  { flag: '🇳🇦', name: 'Namibia', value: 'namibia' },
  { flag: '🇳🇷', name: 'Nauru', value: 'nauru' },
  { flag: '🇳🇵', name: 'Nepal', value: 'nepal' },
  { flag: '🇳🇱', name: 'Netherlands', value: 'netherlands' },
  { flag: '🇳🇨', name: 'New Caledonia', value: 'new_caledonia' },
  { flag: '🇳🇿', name: 'New Zealand', value: 'new_zealand' },
  { flag: '🇳🇮', name: 'Nicaragua', value: 'nicaragua' },
  { flag: '🇳🇪', name: 'Niger', value: 'niger' },
  { flag: '🇳🇬', name: 'Nigeria', value: 'nigeria' },
  { flag: '🇲🇰', name: 'North Macedonia, Republic of', value: 'north_macedonia' },
  { flag: '🇳🇴', name: 'Norway', value: 'norway' },
  { flag: '🇴🇲', name: 'Oman', value: 'oman' },
  { flag: '🇵🇰', name: 'Pakistan', value: 'pakistan' },
  { flag: '🇵🇼', name: 'Palau', value: 'palau' },
  { flag: '🇵🇸', name: 'Palestine', value: 'palestine' },
  { flag: '🇵🇦', name: 'Panama', value: 'panama' },
  { flag: '🇵🇬', name: 'Papua New Guinea', value: 'papua_new_guinea' },
  { flag: '🇵🇾', name: 'Paraguay', value: 'paraguay' },
  { flag: '🇵🇪', name: 'Peru', value: 'peru' },
  { flag: '🇵🇭', name: 'Philippines', value: 'philippines' },
  { flag: '🇵🇳', name: 'Pitcairn Island', value: 'pitcairn_island' },
  { flag: '🇵🇱', name: 'Poland', value: 'poland' },
  { flag: '🇵🇹', name: 'Portugal', value: 'portugal' },
  { flag: '🇶🇦', name: 'Qatar', value: 'qatar' },
  { flag: '🇷🇪', name: 'Reunion', value: 'reunion' },
  { flag: '🇷🇴', name: 'Romania', value: 'romania' },
  { flag: '🇷🇺', name: 'Russia', value: 'russia' },
  { flag: '🇷🇼', name: 'Rwanda', value: 'rwanda' },
  { flag: '🇸🇭', name: 'Saint Helena', value: 'saint_helena' },
  { flag: '🇰🇳', name: 'Saint Kitts and Nevis', value: 'saint_kitts_and_nevis' },
  { flag: '🇱🇨', name: 'Saint Lucia', value: 'saint_lucia' },
  { flag: '🇵🇲', name: 'Saint Pierre and Miquelon', value: 'saint_pierre_and_miquelon' },
  { flag: '🇻🇨', name: 'Saint Vincent and the Grenadines', value: 'saint_vincent_and_the_grenadines' },
  { flag: '🇼🇸', name: 'Samoa', value: 'samoa' },
  { flag: '🇸🇲', name: 'San Marino', value: 'san_marino' },
  { flag: '🇸🇹', name: 'Sao Tome and Principe', value: 'sao_tome_and_principe' },
  { flag: '🇸🇦', name: 'Saudi Arabia', value: 'saudi_arabia' },
  { flag: '🇸🇳', name: 'Senegal', value: 'senegal' },
  { flag: '🇷🇸', name: 'Serbia, Republic of', value: 'serbia' },
  { flag: '🇸🇨', name: 'Seychelles', value: 'seychelles' },
  { flag: '🇸🇱', name: 'Sierra Leone', value: 'sierra_leone' },
  { flag: '🇸🇬', name: 'Singapore', value: 'singapore' },
  { flag: '🇸🇽', name: 'Sint Maarten', value: 'sint_maarten' },
  { flag: '🇸🇰', name: 'Slovak Republic', value: 'slovak_republic' },
  { flag: '🇸🇮', name: 'Slovenia', value: 'slovenia' },
  { flag: '🇸🇧', name: 'Solomon Islands', value: 'solomon_islands' },
  { flag: '🇸🇴', name: 'Somalia', value: 'somalia' },
  { flag: '🇿🇦', name: 'South Africa', value: 'south_africa' },
  { flag: '🇸🇸', name: 'South Sudan, Republic of', value: 'south_sudan' },
  { flag: '🇪🇸', name: 'Spain', value: 'spain' },
  { flag: '🇱🇰', name: 'Sri Lanka', value: 'sri_lanka' },
  { flag: '🇸🇩', name: 'Sudan', value: 'sudan' },
  { flag: '🇸🇷', name: 'Suriname', value: 'suriname' },
  { flag: '🇸🇪', name: 'Sweden', value: 'sweden' },
  { flag: '🇨🇭', name: 'Switzerland', value: 'switzerland' },
  { flag: '🇸🇾', name: 'Syrian Arab Republic', value: 'syrian_arab_republic' },
  { flag: '🇹🇼', name: 'Taiwan', value: 'taiwan' },
  { flag: '🇹🇯', name: 'Tajikistan', value: 'tajikistan' },
  { flag: '🇹🇿', name: 'Tanzania', value: 'tanzania' },
  { flag: '🇹🇭', name: 'Thailand', value: 'thailand' },
  { flag: '🇹🇱', name: 'Timor-Leste, Democratic Republic of', value: 'timor_leste' },
  { flag: '🇹🇬', name: 'Togo', value: 'togo' },
  { flag: '🇹🇴', name: 'Tonga', value: 'tonga' },
  { flag: '🇹🇹', name: 'Trinidad and Tobago', value: 'trinidad_and_tobago' },
  { flag: '🇹🇳', name: 'Tunisia', value: 'tunisia' },
  { flag: '🇹🇷', name: 'Turkey, Republic of', value: 'turkey' },
  { flag: '🇹🇲', name: 'Turkmenistan', value: 'turkmenistan' },
  { flag: '🇹🇨', name: 'Turks and Caicos Islands', value: 'turks_and_caicos_islands' },
  { flag: '🇹🇻', name: 'Tuvalu', value: 'tuvalu' },
  { flag: '🇺🇬', name: 'Uganda', value: 'uganda' },
  { flag: '🇺🇦', name: 'Ukraine', value: 'ukraine' },
  { flag: '🇦🇪', name: 'United Arab Emirates', value: 'united_arab_emirates' },
  { flag: '🇬🇧', name: 'United Kingdom of Great Britain and Northern Ireland', value: 'united_kingdom' },
  { flag: '🇺🇸', name: 'United States', value: 'united_states' },
  { flag: '🇺🇾', name: 'Uruguay', value: 'uruguay' },
  { flag: '🇺🇿', name: 'Uzbekistan', value: 'uzbekistan' },
  { flag: '🇻🇺', name: 'Vanuatu', value: 'vanuatu' },
  { flag: '🇻🇦', name: 'Vatican City', value: 'vatican_city' },
  { flag: '🇻🇪', name: 'Venezuela', value: 'venezuela' },
  { flag: '🇻🇳', name: 'Vietnam', value: 'vietnam' },
  { flag: '🇼🇫', name: 'Wallis and Futuna Islands', value: 'wallis_and_futuna_islands' },
  { flag: '🇾🇪', name: 'Yemen', value: 'yemen' },
  { flag: '🇿🇲', name: 'Zambia', value: 'zambia' },
  { flag: '🇿🇼', name: 'Zimbabwe', value: 'zimbabwe' }
];

export const timezones = [
  { name: 'Yerevan (UTC+4)', value: 'Asia/Yerevan' },
  { name: 'London (UTC+0)', value: 'Europe/London' },
  { name: 'New York (UTC-5)', value: 'America/New_York' },
  { name: 'Los Angeles (UTC-8)', value: 'America/Los_Angeles' },
  { name: 'Tokyo (UTC+9)', value: 'Asia/Tokyo' },
  { name: 'Sydney (UTC+10)', value: 'Australia/Sydney' },
  { name: 'Moscow (UTC+3)', value: 'Europe/Moscow' },
  { name: 'Berlin (UTC+1)', value: 'Europe/Berlin' },
  { name: 'Paris (UTC+1)', value: 'Europe/Paris' },
  { name: 'Rome (UTC+1)', value: 'Europe/Rome' },
  { name: 'Madrid (UTC+1)', value: 'Europe/Madrid' },
  { name: 'Amsterdam (UTC+1)', value: 'Europe/Amsterdam' },
  { name: 'Zurich (UTC+1)', value: 'Europe/Zurich' },
  { name: 'Vienna (UTC+1)', value: 'Europe/Vienna' },
  { name: 'Prague (UTC+1)', value: 'Europe/Prague' },
  { name: 'Warsaw (UTC+1)', value: 'Europe/Warsaw' },
  { name: 'Stockholm (UTC+1)', value: 'Europe/Stockholm' },
  { name: 'Copenhagen (UTC+1)', value: 'Europe/Copenhagen' },
  { name: 'Oslo (UTC+1)', value: 'Europe/Oslo' },
  { name: 'Helsinki (UTC+2)', value: 'Europe/Helsinki' },
  { name: 'Athens (UTC+2)', value: 'Europe/Athens' },
  { name: 'Bucharest (UTC+2)', value: 'Europe/Bucharest' },
  { name: 'Sofia (UTC+2)', value: 'Europe/Sofia' },
  { name: 'Kiev (UTC+2)', value: 'Europe/Kiev' },
  { name: 'Istanbul (UTC+3)', value: 'Europe/Istanbul' },
  { name: 'Dubai (UTC+4)', value: 'Asia/Dubai' },
  { name: 'Tehran (UTC+3:30)', value: 'Asia/Tehran' },
  { name: 'Karachi (UTC+5)', value: 'Asia/Karachi' },
  { name: 'Mumbai (UTC+5:30)', value: 'Asia/Kolkata' },
  { name: 'Dhaka (UTC+6)', value: 'Asia/Dhaka' },
  { name: 'Bangkok (UTC+7)', value: 'Asia/Bangkok' },
  { name: 'Jakarta (UTC+7)', value: 'Asia/Jakarta' },
  { name: 'Singapore (UTC+8)', value: 'Asia/Singapore' },
  { name: 'Hong Kong (UTC+8)', value: 'Asia/Hong_Kong' },
  { name: 'Shanghai (UTC+8)', value: 'Asia/Shanghai' },
  { name: 'Beijing (UTC+8)', value: 'Asia/Shanghai' },
  { name: 'Seoul (UTC+9)', value: 'Asia/Seoul' },
  { name: 'Melbourne (UTC+10)', value: 'Australia/Melbourne' },
  { name: 'Auckland (UTC+12)', value: 'Pacific/Auckland' },
  { name: 'Honolulu (UTC-10)', value: 'Pacific/Honolulu' },
  { name: 'Anchorage (UTC-9)', value: 'America/Anchorage' },
  { name: 'Denver (UTC-7)', value: 'America/Denver' },
  { name: 'Chicago (UTC-6)', value: 'America/Chicago' },
  { name: 'Toronto (UTC-5)', value: 'America/Toronto' },
  { name: 'Mexico City (UTC-6)', value: 'America/Mexico_City' },
  { name: 'São Paulo (UTC-3)', value: 'America/Sao_Paulo' },
  { name: 'Buenos Aires (UTC-3)', value: 'America/Argentina/Buenos_Aires' },
  { name: 'Lima (UTC-5)', value: 'America/Lima' },
  { name: 'Caracas (UTC-4)', value: 'America/Caracas' },
  { name: 'Bogotá (UTC-5)', value: 'America/Bogota' },
  { name: 'Santiago (UTC-4)', value: 'America/Santiago' },
  { name: 'Reykjavik (UTC+0)', value: 'Atlantic/Reykjavik' },
  { name: 'Casablanca (UTC+0)', value: 'Africa/Casablanca' },
  { name: 'Cairo (UTC+2)', value: 'Africa/Cairo' },
  { name: 'Nairobi (UTC+3)', value: 'Africa/Nairobi' },
  { name: 'Johannesburg (UTC+2)', value: 'Africa/Johannesburg' },
  { name: 'Lagos (UTC+1)', value: 'Africa/Lagos' },
  { name: 'Accra (UTC+0)', value: 'Africa/Accra' },
  { name: 'Dakar (UTC+0)', value: 'Africa/Dakar' },
  { name: 'Abidjan (UTC+0)', value: 'Africa/Abidjan' },
  { name: 'Bamako (UTC+0)', value: 'Africa/Bamako' },
  { name: 'Ouagadougou (UTC+0)', value: 'Africa/Ouagadougou' },
  { name: 'Niamey (UTC+1)', value: 'Africa/Niamey' },
  { name: "N'Djamena (UTC+1)", value: 'Africa/Ndjamena' },
  { name: 'Khartoum (UTC+2)', value: 'Africa/Khartoum' },
  { name: 'Addis Ababa (UTC+3)', value: 'Africa/Addis_Ababa' },
  { name: 'Kampala (UTC+3)', value: 'Africa/Kampala' },
  { name: 'Dar es Salaam (UTC+3)', value: 'Africa/Dar_es_Salaam' },
  { name: 'Antananarivo (UTC+3)', value: 'Indian/Antananarivo' },
  { name: 'Port Louis (UTC+4)', value: 'Indian/Mauritius' },
  { name: 'Victoria (UTC+4)', value: 'Indian/Mahe' },
  { name: 'Muscat (UTC+4)', value: 'Asia/Muscat' },
  { name: 'Kuwait City (UTC+3)', value: 'Asia/Kuwait' },
  { name: 'Riyadh (UTC+3)', value: 'Asia/Riyadh' },
  { name: 'Doha (UTC+3)', value: 'Asia/Qatar' },
  { name: 'Manama (UTC+3)', value: 'Asia/Bahrain' },
  { name: 'Abu Dhabi (UTC+4)', value: 'Asia/Dubai' },
  { name: 'Kabul (UTC+4:30)', value: 'Asia/Kabul' },
  { name: 'Tashkent (UTC+5)', value: 'Asia/Tashkent' },
  { name: 'Almaty (UTC+6)', value: 'Asia/Almaty' },
  { name: 'Bishkek (UTC+6)', value: 'Asia/Bishkek' },
  { name: 'Dushanbe (UTC+5)', value: 'Asia/Dushanbe' },
  { name: 'Ashgabat (UTC+5)', value: 'Asia/Ashgabat' },
  { name: 'Ulaanbaatar (UTC+8)', value: 'Asia/Ulaanbaatar' },
  { name: 'Pyongyang (UTC+9)', value: 'Asia/Pyongyang' },
  { name: 'Vladivostok (UTC+10)', value: 'Asia/Vladivostok' },
  { name: 'Magadan (UTC+11)', value: 'Asia/Magadan' },
  { name: 'Kamchatka (UTC+12)', value: 'Asia/Kamchatka' },
  { name: 'Chukotka (UTC+12)', value: 'Asia/Anadyr' },
  { name: 'Anadyr (UTC+12)', value: 'Asia/Anadyr' },
  { name: 'Petropavlovsk-Kamchatsky (UTC+12)', value: 'Asia/Kamchatka' },
  { name: 'Yuzhno-Sakhalinsk (UTC+11)', value: 'Asia/Sakhalin' },
  { name: 'Khabarovsk (UTC+10)', value: 'Asia/Vladivostok' },
  { name: 'Yakutsk (UTC+9)', value: 'Asia/Yakutsk' },
  { name: 'Irkutsk (UTC+8)', value: 'Asia/Irkutsk' },
  { name: 'Krasnoyarsk (UTC+7)', value: 'Asia/Krasnoyarsk' },
  { name: 'Omsk (UTC+6)', value: 'Asia/Omsk' },
  { name: 'Novosibirsk (UTC+7)', value: 'Asia/Novosibirsk' },
  { name: 'Barnaul (UTC+7)', value: 'Asia/Barnaul' },
  { name: 'Tomsk (UTC+7)', value: 'Asia/Tomsk' },
  { name: 'Kemerovo (UTC+7)', value: 'Asia/Novosibirsk' },
  { name: 'Novokuznetsk (UTC+7)', value: 'Asia/Novosibirsk' },
  { name: 'Abakan (UTC+7)', value: 'Asia/Krasnoyarsk' },
  { name: 'Kyzyl (UTC+7)', value: 'Asia/Krasnoyarsk' },
  { name: 'Gorno-Altaysk (UTC+7)', value: 'Asia/Barnaul' },
  { name: 'Birobidzhan (UTC+10)', value: 'Asia/Vladivostok' },
  { name: 'Blagoveshchensk (UTC+9)', value: 'Asia/Yakutsk' },
  { name: 'Chita (UTC+9)', value: 'Asia/Chita' },
  { name: 'Ulan-Ude (UTC+8)', value: 'Asia/Irkutsk' }
];
